import { useEffect, useState } from 'react';
import { useCart } from '../contexts/CartContext';
import { getProdutos } from '../services/api';

export default function Cardapio() {
  const [produtos, setProdutos] = useState({});
  const [busca, setBusca] = useState('');
  const [loading, setLoading] = useState(true);
  const { addItem } = useCart();
  const [toast, setToast] = useState('');
  const API_URL = process.env.REACT_APP_API_URL || '';

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 2500); };

  useEffect(() => {
    getProdutos().then(r => setProdutos(r.data)).finally(() => setLoading(false));
  }, []);

  const handleAdd = (p) => { addItem(p); showToast('🛒 ' + p.nome + ' adicionado!'); };

  const todosItens = Object.values(produtos).flat();
  const filtrados = busca ? todosItens.filter(p => p.nome.toLowerCase().includes(busca.toLowerCase()) || p.descricao?.toLowerCase().includes(busca.toLowerCase())) : null;

  const renderItens = (itens) => (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 8 }}>
      {itens.map(p => (
        <div key={p.id} onClick={() => handleAdd(p)} style={{ background: 'var(--bg3)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden', cursor: 'pointer' }}>
          <div style={{ height: 90, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg4)', fontSize: 44, overflow: 'hidden' }}>
            {p.imagem_url ? <img src={`${API_URL}${p.imagem_url}`} alt={p.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : p.emoji}
          </div>
          <div style={{ padding: 10 }}>
            <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 2, lineHeight: 1.3 }}>{p.nome}</div>
            <div style={{ fontSize: 10, color: 'var(--text2)', marginBottom: 6, lineHeight: 1.3 }}>{p.descricao}</div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <span style={{ fontSize: 14, fontWeight: 800, color: 'var(--orange)' }}>R$ {parseFloat(p.preco).toFixed(2).replace('.', ',')}</span>
              <button onClick={e => { e.stopPropagation(); handleAdd(p); }} style={{ background: 'var(--red)', border: 'none', color: '#fff', width: 26, height: 26, borderRadius: '50%', cursor: 'pointer', fontSize: 16 }}>+</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      {toast && <div style={{ position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999, whiteSpace: 'nowrap' }}>{toast}</div>}
      <h2>🍔 Cardápio</h2>
      <input className="input-field" placeholder="🔍 Buscar..." value={busca} onChange={e => setBusca(e.target.value)} style={{ marginBottom: 16 }} />
      {loading ? <div className="spinner" /> : busca ? (
        filtrados.length ? renderItens(filtrados) : <div className="empty-state"><div className="icon">🔍</div><p>Nenhum item encontrado</p></div>
      ) : (
        Object.entries(produtos).map(([cat, itens]) => (
          <div key={cat}>
            <div style={{ fontSize: 15, fontWeight: 800, margin: '16px 0 10px' }}>{cat}</div>
            {renderItens(itens)}
          </div>
        ))
      )}
    </div>
  );
}
